import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '@/utils/api';
import { KITCHEN_MINUTES, kitchenThresholds } from '@/theme/statusColors';

// Minutos de "atrasado" y "muy atrasado" del negocio (los mismos para cocina y TV)
export const useKitchenThresholds = () => {
  const [t, setT] = useState(KITCHEN_MINUTES);
  useEffect(() => {
    axios.get(`${API_BASE}/business/settings`).then(r => setT(kitchenThresholds(r.data))).catch(() => {});
  }, []);
  return t;
};
